import React from "react";
import { Button, ButtonToolbar, Table } from "components/bootstrap";
const InputsTable = ({
  inputs,
  inputTypes,
  onInputDelete = () => {
  },
  onInputEdit = () => {
  },
  withActions = false
}) => /* @__PURE__ */ React.createElement(Table, { striped: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Title"), /* @__PURE__ */ React.createElement("th", null, "Type"), withActions && /* @__PURE__ */ React.createElement("th", null, "\xA0"))), /* @__PURE__ */ React.createElement("tbody", null, inputs.map((input) => {
  const { title, type } = input;
  return /* @__PURE__ */ React.createElement("tr", { key: title }, /* @__PURE__ */ React.createElement("td", null, title), /* @__PURE__ */ React.createElement("td", null, inputTypes[type] ? inputTypes[type] : type), withActions && // eslint-disable-next-line jsx-a11y/control-has-associated-label
  /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", onClick: () => onInputDelete(input) }, "Delete"), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "xs", onClick: () => onInputEdit(input) }, "Edit"))));
})));
export default InputsTable;
